/**
 * @file Email verification notice view.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import get from 'lodash.get';

import MainLayout from '../layouts/MainLayout';
import ContentWrap from '../../components/global/ContentWrap';
import EmailVerificationNoticeContainer from '../../containers/auth/EmailVerificationNoticeContainer';

const propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      emailConfirmUrlRedirect: PropTypes.string,
    }),
  }),
};

const EmailVerificationNoticeView = ({ location }) => (
  <MainLayout>
    <Helmet>
      <title>Email verification &ndash; Waldo</title>
    </Helmet>

    <ContentWrap size="sm">
      <EmailVerificationNoticeContainer
        redirectUrl={get(location, 'state.emailConfirmUrlRedirect')}
      />
    </ContentWrap>
  </MainLayout>
);

EmailVerificationNoticeView.propTypes = propTypes;

export default compose(withRouter)(EmailVerificationNoticeView);
